import React from 'react';
import { Phone, CheckCircle, Briefcase, FileSearch, Shield, TrendingUp } from 'lucide-react';
export function ProfessionalWitnessPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-8113">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-8114">
        <div className="container mx-auto px-4" data-id="element-8115">
          <p className="text-center text-lg mb-4 italic" data-id="element-8116">
            Serving Farmington Hills, Farmington, Novi, Livonia, Northville
            Since 1958
          </p>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-8117">
            Professional Witness Service
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-8118">
            Truck and Equipment Expert Witness
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-8119">
        <div className="max-w-5xl mx-auto" data-id="element-8120">
          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8121">
            <div className="flex items-center mb-6" data-id="element-8122">
              <Briefcase className="text-[#B1050B] mr-4" size={40} data-id="element-8123" />
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-8124">
                Truck and Equipment Expert Witness
              </h2>
            </div>

            <p className="text-lg text-gray-700 mb-6" data-id="element-8125">
              <strong data-id="element-8126">Garrett Auto And Truck Service</strong> provides
              comprehensive expert witness and consulting services for truck and
              equipment matters.
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-8127">
            {/* Onsite Inspections */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow" data-id="element-8128">
              <div className="flex items-start mb-4" data-id="element-8129">
                <div className="bg-blue-100 rounded-lg p-3 mr-4" data-id="element-8130">
                  <FileSearch className="text-blue-600" size={28} data-id="element-8131" />
                </div>
                <div data-id="element-8132">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-8133">
                    Onsite Equipment Safety Inspection
                  </h3>
                  <p className="text-gray-600" data-id="element-8134">
                    Post accident inspection and comprehensive safety
                    evaluations
                  </p>
                </div>
              </div>
            </div>

            {/* Equipment Specifications */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow" data-id="element-8135">
              <div className="flex items-start mb-4" data-id="element-8136">
                <div className="bg-green-100 rounded-lg p-3 mr-4" data-id="element-8137">
                  <CheckCircle className="text-green-600" size={28} data-id="element-8138" />
                </div>
                <div data-id="element-8139">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-8140">
                    Equipment Specifications
                  </h3>
                  <p className="text-gray-600" data-id="element-8141">
                    Evaluating equipment specifications - buy the right
                    equipment the first time
                  </p>
                </div>
              </div>
            </div>

            {/* Lease & Purchase Evaluation */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow" data-id="element-8142">
              <div className="flex items-start mb-4" data-id="element-8143">
                <div className="bg-purple-100 rounded-lg p-3 mr-4" data-id="element-8144">
                  <TrendingUp className="text-purple-600" size={28} data-id="element-8145" />
                </div>
                <div data-id="element-8146">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-8147">
                    Lease & Purchase Negotiation
                  </h3>
                  <p className="text-gray-600" data-id="element-8148">
                    Evaluating and negotiating equipment leases and purchases -
                    Used or New equipment
                  </p>
                </div>
              </div>
            </div>

            {/* Trade Cycles */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow" data-id="element-8149">
              <div className="flex items-start mb-4" data-id="element-8150">
                <div className="bg-orange-100 rounded-lg p-3 mr-4" data-id="element-8151">
                  <Shield className="text-orange-600" size={28} data-id="element-8152" />
                </div>
                <div data-id="element-8153">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-8154">
                    Equipment Trade Cycles
                  </h3>
                  <p className="text-gray-600" data-id="element-8155">
                    Determining optimal equipment trade cycles for maximum value
                  </p>
                </div>
              </div>
            </div>

            {/* Maintenance Auditing */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow" data-id="element-8156">
              <div className="flex items-start mb-4" data-id="element-8157">
                <div className="bg-red-100 rounded-lg p-3 mr-4" data-id="element-8158">
                  <FileSearch className="text-red-600" size={28} data-id="element-8159" />
                </div>
                <div data-id="element-8160">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-8161">
                    Maintenance Operations Auditing
                  </h3>
                  <p className="text-gray-600" data-id="element-8162">
                    Auditing for scheduled maintenance operations and compliance
                  </p>
                </div>
              </div>
            </div>

            {/* Cost Tracking */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow" data-id="element-8163">
              <div className="flex items-start mb-4" data-id="element-8164">
                <div className="bg-teal-100 rounded-lg p-3 mr-4" data-id="element-8165">
                  <TrendingUp className="text-teal-600" size={28} data-id="element-8166" />
                </div>
                <div data-id="element-8167">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-8168">
                    Maintenance Cost Evaluation
                  </h3>
                  <p className="text-gray-600" data-id="element-8169">
                    Evaluating and tracking maintenance costs for budget
                    optimization
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Budgeting Plan */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-8170">
            <div className="flex items-center mb-4" data-id="element-8171">
              <Briefcase className="mr-4" size={32} data-id="element-8172" />
              <h3 className="text-2xl font-bold" data-id="element-8173">
                Custom Tailored Budgeting Plan
              </h3>
            </div>
            <p className="text-lg text-gray-100" data-id="element-8174">
              Evaluating and implementing a custom tailored budgeting plan
              designed specifically for your fleet and equipment needs
            </p>
          </div>

          {/* Complete Services List */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8175">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-8176">
              Complete Services Overview
            </h2>

            <div className="space-y-4" data-id="element-8177">
              <div className="flex items-start" data-id="element-8178">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8179" />
                <p className="text-gray-700" data-id="element-8180">
                  <strong data-id="element-8181">
                    Onsite equipment safety inspection or post accident
                    inspection
                  </strong>
                </p>
              </div>

              <div className="flex items-start" data-id="element-8182">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8183" />
                <p className="text-gray-700" data-id="element-8184">
                  <strong data-id="element-8185">Evaluating equipment specifications</strong> - buy the
                  right equipment the first time
                </p>
              </div>

              <div className="flex items-start" data-id="element-8186">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8187" />
                <p className="text-gray-700" data-id="element-8188">
                  <strong data-id="element-8189">
                    Evaluating and negotiating equipment leases and purchases
                  </strong>{' '}
                  - Used or New equipment
                </p>
              </div>

              <div className="flex items-start" data-id="element-8190">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8191" />
                <p className="text-gray-700" data-id="element-8192">
                  <strong data-id="element-8193">Determining equipment trade cycles</strong>
                </p>
              </div>

              <div className="flex items-start" data-id="element-8194">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8195" />
                <p className="text-gray-700" data-id="element-8196">
                  <strong data-id="element-8197">Auditing for scheduled maintenance operations</strong>
                </p>
              </div>

              <div className="flex items-start" data-id="element-8198">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8199" />
                <p className="text-gray-700" data-id="element-8200">
                  <strong data-id="element-8201">Evaluating and tracking maintenance costs</strong>
                </p>
              </div>

              <div className="flex items-start" data-id="element-8202">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8203" />
                <p className="text-gray-700" data-id="element-8204">
                  <strong data-id="element-8205">
                    Evaluating and implementing a custom tailored budgeting plan
                  </strong>
                </p>
              </div>
            </div>
          </div>

          {/* Featured Service Highlight */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-8206">
            <div className="flex flex-col md:flex-row items-center" data-id="element-8207">
              <div className="flex-1 mb-6 md:mb-0 md:mr-8" data-id="element-8208">
                <h2 className="text-3xl font-bold mb-4" data-id="element-8209">
                  Onsite Equipment Safety Inspection
                </h2>
                <p className="text-xl text-gray-100 mb-4" data-id="element-8210">
                  Post accident inspection and comprehensive safety evaluations
                </p>
                <p className="text-gray-200" data-id="element-8211">
                  Our expert team provides thorough onsite inspections to
                  evaluate equipment safety, identify potential issues, and
                  provide detailed reports for legal and insurance purposes.
                </p>
              </div>
              <div className="flex-shrink-0" data-id="element-8212">
                <div className="bg-white/10 rounded-lg p-6" data-id="element-8213">
                  <Shield className="text-white" size={80} data-id="element-8214" />
                </div>
              </div>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8215">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-8216">
              Why Choose Garrett Auto & Truck Service?
            </h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-8217">
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-8218">
                <h3 className="font-bold text-blue-900 mb-3" data-id="element-8219">
                  65+ Years of Experience
                </h3>
                <p className="text-gray-700" data-id="element-8220">
                  Serving the community since 1958 with unmatched expertise
                </p>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-8221">
                <h3 className="font-bold text-green-900 mb-3" data-id="element-8222">
                  Comprehensive Knowledge
                </h3>
                <p className="text-gray-700" data-id="element-8223">
                  Deep understanding of truck and equipment systems,
                  specifications, and industry standards
                </p>
              </div>

              <div className="bg-purple-50 rounded-lg p-6" data-id="element-8224">
                <h3 className="font-bold text-purple-900 mb-3" data-id="element-8225">
                  Detailed Reporting
                </h3>
                <p className="text-gray-700" data-id="element-8226">
                  Thorough documentation and expert testimony for legal
                  proceedings
                </p>
              </div>

              <div className="bg-orange-50 rounded-lg p-6" data-id="element-8227">
                <h3 className="font-bold text-orange-900 mb-3" data-id="element-8228">
                  Local Expertise
                </h3>
                <p className="text-gray-700" data-id="element-8229">
                  Serving Farmington Hills, Farmington, Novi, Livonia, and
                  Northville
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-8230">
            <h2 className="text-3xl font-bold mb-4" data-id="element-8231">
              Need Expert Witness Services?
            </h2>
            <p className="text-xl mb-6" data-id="element-8232">
              Contact us for professional truck and equipment expert witness
              consultation
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-8233">
              <Phone className="mr-3" size={24} data-id="element-8234" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-8235">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
            <p className="mt-2 text-gray-400 text-sm" data-id="element-8236">
              Serving the community since 1958
            </p>
          </div>
        </div>
      </div>
    </div>;
}